import { useTranslation } from "react-i18next"
import React, { useState } from "react";

import MemberCard from '../Cards/MemberCard';
import Modal from '../Cards/Modal';

const About = ({aboutRef, handleAlert}) => {

    const { t } = useTranslation('global');
    const translationPrefix = 'About';
    
    const members = ['lorenae', 'amarotta', 'gutierre', 'fcarpani', 'fserra', 'sparra', 'csanz', 'ccortes', 'mdolgay', 'ymichelena', 'precarte']
    const [open, setOpen] = useState(false);
    const [memberClicked, setMemberClicked] = useState('');

    const handleOpen = (id) => {
        setMemberClicked(members.find(x => x === id));
        setOpen(() => !open);
    };

    return(
        <section ref={aboutRef} className="py-24 ">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center text-center mb-16">
              <div className="w-full lg:w-6/12 px-4">
                <h2 className="text-4xl font-semibold">{t(`${translationPrefix}.title`)}</h2>
                {/* <p className="text-lg leading-relaxed m-4 text-blueGray-500">
                  {t(`${translationPrefix}.description`)}
                </p> */}
              </div>
            </div>
            <div className="flex flex-wrap">
              {
                members.map((member) => {
                  return(
                    <React.Fragment key={member}>
                      <MemberCard 
                        member={member}
                        handleOpen={handleOpen}
                        setOpenSnackbar={handleAlert} />
                        {
                          memberClicked !== '' &&
                          <Modal 
                            id={member}
                            handleOpen={handleOpen}
                            member={memberClicked} 
                            open={open}
                           />  
                        }                   
                    </React.Fragment>
                  )
                })
              }
            </div>
          </div>
        </section>
    )
}

export default About;